import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-parchment-deep text-ink" data-id="element-67" data-mp="1lc231ky1rhuv">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-68" data-mp="1gdgzpcni0i27">
        <h2 className="text-center font-display text-[1.875rem] font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-69" data-mp="2e067620yzmvg">
          Preguntas frecuentes
        </h2>

        <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-70" data-mp="2924o3h3jnnjz">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-2xl border border-parchment-line bg-white" data-id="element-71" data-mp="1z25h3omrw598" data-mpi={index}>
                <h3 data-id="element-72" data-mp="noa0sck4tqgf">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 px-5 py-4 text-left font-sans text-base font-semibold text-ink transition-colors duration-150 ease-out hover:text-gold-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink sm:gap-6 sm:px-6 sm:py-5" data-id="element-73" data-mp="nnqszoo74ig4">
                    {faq.question}
                    <PlusIcon aria-hidden="true" className={`mt-0.5 h-5 w-5 flex-none text-gold-deep transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-74" data-mp="6plno14kje4g" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-75" data-mp="3jxq59m5dmhfn">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-76" data-mp="3nzbqbus2e20x">
                      <p className="px-5 pb-5 font-sans text-[0.95rem] leading-relaxed text-ink-soft sm:px-6 sm:pb-6" data-id="element-77" data-mp="1krb64xc7qtyv">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}